import styled from 'styled-components';

import { DisplayButton } from './DisplayButton';

export const SolidButton = styled(DisplayButton)`
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc(-100% - 15px);
    width: 100%;
    transform: skew(-20deg);
    transition: all 1.5s ease-out;
    background: ${({ theme }) => theme.gold[80]};
    opacity: 0.15;
  }

  &:hover {
    color: ${({ theme }) => theme.black[100]};

    &:before {
      left: -20px;
      width: calc(100% + 40px);
    }
  }
  
  &:disabled {
    &:before {
      display: none;
    }
  }
`;
